import { render, staticRenderFns } from "./ComButtonIcon.vue?vue&type=template&id=5aadf9fc&"
import script from "./ComButtonIcon.vue?vue&type=script&lang=js&"
export * from "./ComButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./ComButtonIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\2-Projects\\1-asva\\5-vue-book\\1-vue-book\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5aadf9fc', component.options)
    } else {
      api.reload('5aadf9fc', component.options)
    }
    module.hot.accept("./ComButtonIcon.vue?vue&type=template&id=5aadf9fc&", function () {
      api.rerender('5aadf9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\components\\DemoPage\\ComButtonIcon\\ComButtonIcon.vue"
export default component.exports